/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

export const enum TitleVariants {
  '2xl' = '2xl',
  Xl = 'xl',
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xs = 'xs',
}

export const enum TextVariants {
  TitleXl = 'title-xl',
  TitleLg = 'title-lg',
  TitleMd = 'title-md',
  TitleSm = 'title-sm',
  TitleXs = 'title-xs',
  Title2Xs = 'title-2xs',
  BodyLg = 'body-lg',
  BodyMd = 'body-md',
  BodySm = 'body-sm',
  BodyXs = 'body-xs',
}

export const enum CodeVariants {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xs = 'xs',
}
